import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询列表
export const queryTemplates: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setTemplates', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/message/template/page', payload);
    commit('setTemplates', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setTemplates', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查看详情
export const queryTemplateDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setTemplateDetail', { data: null, loading: true });
    const res: IPageData = await $http.get(`/message/template/get/${payload}`);
    commit('setTemplateDetail', { data: res });
  } catch (e) {
    commit('setTemplateDetail', { data: null });
  }
};

// 添加
export const addTemplate: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/message/template/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-template' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑
export const editTemplate: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/message/template/edit', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-template' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 删除
export const deleteTemplate: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/message/template/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
